module.exports = __webpack_public_path__ + "img/folder6.b3be3024.png";